import { css } from '@emotion/react';

export const app = css`
    body {
      overflow: hidden;
    }

    // This class is on a hard coded div in the main index.hml template,
    // it acts as the react root element.
    .application {
        height: 100vh;
        overflow: hidden;
    }

    // build version number, display after trooper build after deploy to demo|qa|live
    .version-number {
        position: fixed;
        right: 0;
        bottom: 0;
        z-index: 999999;
        color: #aaa;
        font-size: 9px;
    }
  
    // Custom scrollbar as per prev portal implementation.
    // todo: maybe manage this in separate file and import for clarity if this file grows to large.
    ::-webkit-scrollbar {
        width: 0.5em;
        height: 0.5em;
    }
    
    ::-webkit-scrollbar-thumb {
        background: #d9d9d9;
        cursor: pointer;
    }
    
    ::-webkit-scrollbar-track {
        background: transparent;
    }
`;
